export default __webpack_public_path__ + "static/media/logo-college.df0570e8.png";